import React from 'react';
import './LoginModalRegister.css';
import './LoginModal.css';
import RegisterForm from './RegisterForm';
import { useLoginModalContext } from '../../context/LoginModalContext';
import { X, Sun } from 'lucide-react';

interface UserRegistrationModalProps {  
  onClose: () => void;
  onRegister: (email: string) => void;
}

const UserRegistrationModal: React.FC<UserRegistrationModalProps> = ({ 
  onClose,
  onRegister
}) => {

  const { setCurrentStep } = useLoginModalContext();

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button 
            className="modal-close-btn" 
            onClick={onClose}
            aria-label="Close modal"
          >
            <X size={20} />
          </button>

          <h1 className="modal-title">Join the Holiday Fun!</h1>
          
          <p className="modal-description">
            To save this camp we just need your name and email.
            It only takes a few seconds, and you'll be able to:
          </p>
          <ul className="modal-benefits">
            <li>Save your favorite camps</li>
            <li>Get personalized recommendations</li>
            <li>Come back anytime and pick up where you left off</li>
          </ul>
          
          <RegisterForm onRegister={onRegister} onClose={onClose} />

          <p className="login-link">
            Already have an account? <button 
              type="button" 
              className="login-link-text" 
              onClick={() => setCurrentStep('email')}
            >
              Sign in
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default UserRegistrationModal;
